import React, { Component } from 'react';
import MaterialTable from 'material-table';
import{ SERVER_PATH, AXIOS_CONFIG} from '../common/redux/constantes';
import moment from 'moment';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from './redux/actions';



class Cir extends Component {
  static propTypes = {

  };


  state ={
    openCompletionDialog:false
  }

  constructor(props) {
    super(props);
    this.tableRef = React.createRef();
  }


  handleClickOpen = (workpackage) => {
    this.setState({ openCompletionDialog: true, workpackageSelected:workpackage.workpackage});
  };

  handleClose = () => {
    this.setState({ openCompletionDialog: false });
    this.refreshTable();
  };

  refreshTable=()=>
  {
    this.tableRef.current && this.tableRef.current.onQueryChange()
  }

  render() {
    let actionButtons = [{
          icon: 'refresh',
          tooltip: 'Refresh Data',
          isFreeAction: true,
          onClick: () => this.tableRef.current && this.tableRef.current.onQueryChange()
        }
    ];


    return (
      <div className="summary-generic-cost">
          <MaterialTable
          tableRef={this.tableRef}
          onRowClick={((evt, selectedRow) => this.setState({ selectedRow }))}
          options={{
            actionsColumnIndex:7,
            paging:false,
            search:false,
            sorting:false,
            maxBodyHeight:"600px",
            headerStyle: {
              backgroundColor: '#FFF',
              color: '#000',
              fontSize:'1.05em'
            },
            rowStyle: rowData => ({
            })
          }}
          title="Control Accounts in Reporting Periods"
          columns={[
            { 
              title: 'RP', 
              field: 'reporting_number',
              cellStyle: {
                borderRight: "1px solid #d4d4d4"
              }
            },
            { 
              title: 'Control Account', 
              field: 'ca_name',
              cellStyle: {
                borderRight: "1px solid #d4d4d4"
              }
            },
            { 
              title: 'WP', 
              field: 'total_w',
              cellStyle: {
                borderRight: "1px solid #d4d4d4"
              }
            },
            { 
              title: 'Completed', 
              field: 'completed_w',
              cellStyle: {
                borderRight: "1px solid #d4d4d4"
              }
            },
            { 
              title: 'Planned Value', 
              field: 'planned_value',
              cellStyle: {
                borderRight: "1px solid #d4d4d4"
              }
            },
            { 
              title: 'Earned Value', 
              field: 'earned_value',
              cellStyle: {
                borderRight: "1px solid #d4d4d4"
              }
            },
            { 
              title: 'Actual Cost', 
              field: 'actual_cost',
              cellStyle: {
                borderRight: "1px solid #d4d4d4"
              }
            },
          ]}
         data={query =>
          new Promise((resolve, reject) => {
            let url = SERVER_PATH + '/projects/CaInRps/' + this.props.project;
            fetch(url,AXIOS_CONFIG())
              .then(response => response.json())
              .then(result => {
                 let formatter = null;
                if (typeof Intl === 'object' && typeof Intl.NumberFormat === 'function') 
                {
                  formatter = new Intl.NumberFormat('gt-GT', {
                    minimumFractionDigits: 2,
                  });
                }

                let cumulative_actual = 0;
                let cumulative = 0;
                let cumulative_earned = 0;

                result.rps = result.rps.map(o => {
                  if(o.start_date && o.end_date)
                  {
                    o.start_date= moment(o.start_date).format('YYYY-MM-DD')
                    o.end_date= moment(o.end_date).format('YYYY-MM-DD')
                  }
                  if (typeof Intl === 'object' && typeof Intl.NumberFormat === 'function') 
                  {
                    cumulative += Number(o.planned_value);
                    cumulative_earned += Number(o.earned_value);
                    cumulative_actual += Number(o.actual_cost);
                    o.cumulative = cumulative;
                    o.cumulative_earned = cumulative_earned;
                    o.planned_value = formatter.format(o.planned_value);
                    o.cumulative = formatter.format(o.cumulative);
                    o.earned_value = formatter.format(o.earned_value);
                    o.cumulative_earned = formatter.format(o.cumulative_earned);
                    o.actual_cost = formatter.format(o.actual_cost);
                    o.cumulative_actual = formatter.format(cumulative_actual);
                  }
                  return o;
                });
                resolve({
                  data: result.rps,
                  page: 0,
                  totalCount: result.rps.length,
                });
              })
              .catch(err => {resolve({data:[], page: 0, totalCount:0})})
          })
        }
          actions={actionButtons}
        />
      </div>
    );
  }
}

/* istanbul ignore next */
function mapStateToProps(state) {
  return {
    cir: state.cir,
  };
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch)
  };
}


export default connect(
  mapStateToProps,
  mapDispatchToProps
)((Cir));



// WEBPACK FOOTER //
// ./src/features/cir/Cir.js